/**
 * Your Crew beta registry soft-copy
 *
 * Tiny client-safe constant so `lib/beta-features/registry.ts` can mount
 * Your Crew without importing the full feed-digest module tree.
 * Keep in lockstep with CREW_YOUR_CREW_PAGE_TITLE ('Crew') in feed-digest.
 */

export const CREW_YOUR_CREW_BETA_REGISTRY_BLURB = 'Crew'
